export const EC_INTEGRATION_TEST_URL = 'https://github.com/conforma/tekton-catalog';
export const EC_INTEGRATION_TEST_REVISION = 'main';
export const EC_INTEGRATION_TEST_PATH = 'pipelines/enterprise-contract/0.1/enterprise-contract.yaml';
export const EC_INTEGRATION_TEST_KIND = 'enterprise-contract';
